import { WhyChooseInvozioSection } from "./why-choose-invozio-section.component";
import { ChooseInvoice } from "./images/png/icons";
import { dollar, Frame } from "./images/svg/icons";
import { useTranslation } from "react-i18next";
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from "react-router-dom";

export const ChooseInvozio = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function navigateToRoute(EnglishPath:string, swedishPath:string) {
    navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': swedishPath, 'en-us': EnglishPath }));
  }
  return (
    <section className="choose-invozio-container">
      <WhyChooseInvozioSection
        image={ChooseInvoice}
        imageAlt={t("CHOOSE_INVOZIO_IMAGE_ALT")}
        title={t("CHOOSE_INVOZIO_FOR_YOUR_BUSINESS")}
        description={t("CHOOSE_INVOZIO_DESCRIPTION")}
        features={[
          {
            icon: dollar,
            title: t("COST_SAVINGS_WITH_TRANSPARENT_PRICING"),
            description: t("COST_SAVINGS_WITH_TRANSPARENT_PRICING_DESC"),
          },
          {
            icon: Frame,
            title: t("EFFICIENCY_AND_GROWTH_FOCUS"),
            description: t("EFFICIENCY_AND_GROWTH_FOCUS_DESC"),
          },
        ]}
        buttonText={t("READ_MORE")}
        navigateToRoute={navigateToRoute}
      />
    </section>
  );
};
